export const DEFAULT_USERS = 'https://cdn.explicae.com.br/public/platform/avatar/avatar.jpg';
